var map = {
	"./CompanyDB.PNG": "./src/img/CompanyDB.PNG",
	"./JR.png": "./src/img/JR.png",
	"./asbservices.PNG": "./src/img/asbservices.PNG",
	"./azuredevops.png": "./src/img/azuredevops.png",
	"./c-sharp.png": "./src/img/c-sharp.png",
	"./calc.PNG": "./src/img/calc.PNG",
	"./champions.PNG": "./src/img/champions.PNG",
	"./chatapp.gif": "./src/img/chatapp.gif",
	"./css3.svg": "./src/img/css3.svg?6fca",
	"./currency.PNG": "./src/img/currency.PNG",
	"./ef8.png": "./src/img/ef8.png",
	"./empList.PNG": "./src/img/empList.PNG",
	"./express.png": "./src/img/express.png",
	"./firebase.png": "./src/img/firebase.png",
	"./flask.png": "./src/img/flask.png",
	"./githubIcon.svg": "./src/img/githubIcon.svg?7f0b",
	"./gitlab.png": "./src/img/gitlab.png",
	"./html5.png": "./src/img/html5.png",
	"./java.png": "./src/img/java.png",
	"./js.png": "./src/img/js.png",
	"./land.PNG": "./src/img/land.PNG",
	"./linkedinIcon.svg": "./src/img/linkedinIcon.svg?ce2f",
	"./manager.svg": "./src/img/manager.svg?867f",
	"./mongo.png": "./src/img/mongo.png",
	"./mysql.png": "./src/img/mysql.png",
	"./net-icon.svg": "./src/img/net-icon.svg",
	"./node.png": "./src/img/node.png",
	"./php.svg": "./src/img/php.svg",
	"./pong.PNG": "./src/img/pong.PNG",
	"./project.svg": "./src/img/project.svg?b3b6",
	"./propfinder.png": "./src/img/propfinder.png",
	"./python.png": "./src/img/python.png",
	"./react.png": "./src/img/react.png",
	"./react.svg": "./src/img/react.svg",
	"./resumeIcon.svg": "./src/img/resumeIcon.svg?1d22",
	"./sql.svg": "./src/img/sql.svg?746a",
	"./sqlite.png": "./src/img/sqlite.png",
	"./sqlserver.svg": "./src/img/sqlserver.svg",
	"./startbg.jpg": "./src/img/startbg.jpg",
	"./typescript.png": "./src/img/typescript.png",
	"./virtualKeyboard.PNG": "./src/img/virtualKeyboard.PNG",
	"./vuejs.png": "./src/img/vuejs.png",
	"./xunit.png": "./src/img/xunit.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive ^\\.\\/.*$";